export default __webpack_public_path__ + "media/images/front/municipality_collaboration/imabari/ogp-3500da7cec721406d6baadec3c654e69.png";